import React, {useEffect, useState} from 'react';
import { withRouter } from 'react-router-dom';
import {UpdatePayment} from "./UpdatePayment";
import {
    deleteInvoice,
    fetchInvoices,
    getLastInventory,
    updateInvoice
} from "../../../action";
import {useDispatch, useSelector} from "react-redux";
import {formatDateTime} from "../../../utils/formatDateTime";
import swal from 'sweetalert';
import Content from "../../../components/layout/Content";
import ReactTooltip from "react-tooltip";
import ActionMenu from "../../../components/utils/ActionMenu";
import { isEmpty } from 'lodash';
import moment from 'moment';
import request from '../../../action/utils/request';
import { urls } from '../../../constants/app';
import { addArticleWorkingShift } from '../../../action/cassa';
import { parseNumToFixed } from '../../../utils/common';
import { fetchSettings } from '../../../action/app';
import { fetchArticleCash } from '../../../action/handbook';

const renderAdress = (point) => {
    if (!point) return 'Адрес не указан';
    const cityName = point.city ? point.city.name : 'Город не указан';
    const street = point.street ? point.street : 'Улица не указана';
    const house = point.house ? point.house : '';
    
    return `${cityName}, ${street} ${house}`;
};

const Item = ({ item, history }) => {
    const settings = useSelector(state => state.settings.init);
    const articles = useSelector(state => state.handbook.articlesCash);

    const dispatch = useDispatch();
    const paidFor = item.payment && item.payment !== 'none';
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        isEmpty(settings) && dispatch(fetchSettings());
    }, [dispatch, settings]);

    const handleSubmit = async (payment, workingShiftId, refund) => {
        const articlesCash = settings.articlesCash || {};
        const text = refund ? 'Возврат оплаты накладной' : 'Оплата накладной';
        const date = item.date ? item.date : item.created_at;
        const textDate = moment(date).format('DD.MM.YYYY HH:mm');
        const data = {
            typeTransaction: payment,
            sum: item.totalSum,
            name: text,
            notRefunded: true,
            typeMovementCash: refund ? 'income' : 'expenditure',
            invoiceId: item.id,
            movementPay: refund ? 'refund' : 'pay',
            comment: `${text} №${item.number || item.id} от ${textDate}`,
        }

        if (refund) data.refund = true;
        
        if (articlesCash.paymentInvoice) {
            const id = parseInt(articlesCash.paymentInvoice)
            data.articleId = id;

            let name = null;
            
            if (articles && articles.length > 0) {
                const entity = articles.find((article) => article.id === id);
                if (entity && entity.name) name = entity.name;
            }

            if (!name) {
                const entity = await dispatch(fetchArticleCash(id));
                if (entity && entity.name) name = entity.name;
            }

            if (name) data.name = name;
        }
        // } else {
        //     return swal({
        //         title: 'Ошибка сохранения данных',
        //         text: 'Не найдена статья "Оплата накладной"',
        //         icon: 'error',
        //         dangerMode: true,
        //         button: 'Ок',
        //     })
        // }
        const addArticle = await dispatch(addArticleWorkingShift(data, workingShiftId, false));
        if (addArticle) dispatch(updateInvoice(item.id, {payment: refund ? 'none' : payment, paymented_at: refund ? null : new Date()}));
        setIsModalOpen(false);
        dispatch(fetchInvoices())
    };

    const handlePaymentMethod = async (method, refund) => {
        const getWorkingShift = async () => {
            const params = {
                'closed_at_null': true,
                'point.id': item.point.id
            };
            const workingShift = await request({ method: 'get', url: urls.workingShift, params });
            return workingShift;
        }

        const workingShift = await getWorkingShift();
        if (workingShift.length <= 0) return swal({
            title: "Смена закрыта",
            text: "Смена закрыта, оплата невозможна. Откройте смену и повторите попытку.",
            icon: "warning",
            dangerMode: true,
            button: "Ок",
        });

        handleSubmit(method, workingShift[0].id, refund);
    };

    const fullAddress = renderAdress(item.point);

    const openCopy = async () => {
        history.push({
            pathname: `/accounting/invoice/form`,
            state: { invoiceId: item.id }
        })
    }

    const openEdit = async () => {
        if (paidFor) {
            return swal({
                title: `Редактирование невозможно`,
                text: 'Накладная оплачена',
                icon: "warning",
                dangerMode: true,
                button: "Ок",
            });
        };
        
        history.push(`/accounting/invoice/edit/${item.id}`)
    }

    const onDeleteInvoice = async () => {
        if (paidFor) {
            return swal({
                title: `Удаление невозможно`,
                text: 'Накладная оплачена',
                icon: "warning",
                dangerMode: true,
                button: "Ок",
            });
        };
        const lastInventory = await dispatch(getLastInventory(item.point));

        if (lastInventory && lastInventory.error) {
            return swal({
                title: `Удаление невозможно`,
                text: lastInventory.error.message || '',
                icon: "warning",
                dangerMode: true,
                button: "Ок",
            });
        };

        if (!isEmpty(lastInventory) && moment(lastInventory.date) > moment(item.date)) {
            return swal({
                title: `Удаление невозможно`,
                text: 'Была проведена инвентаризация',
                icon: "warning",
                dangerMode: true,
                button: "Ок",
            });
        }

        const street = item.point && item.point.street ? item.point.street : 'Адрес неизвестен';
        const house = item.point && item.point.house ? item.point.house : '';

        swal({
            title: `Удаление накладной`,
            text: `Вы действительно котите удалить накладную № ${item.number} по филиалу ${street} ${house}?`,
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Удалить"],
        }).then((willDelete) => {
            if (willDelete) {
                dispatch(deleteInvoice(item.id))
                    .then(() => {
                        swal("Успех!", "Накладная была успешно удалена.", "success");
                    })
                    .catch(() => {});
            }
        });
    };


    const actions = [
        { name: 'Просмотр', icon: 'la la-eye', action: () => history.push(`/accounting/invoice/detail/${item.id}`) },
        { name: 'Копировать', icon: 'la la-copy', action: () => openCopy()},
        ...(!paidFor ? [{name: 'Оплатить из кассы', icon: 'la la-credit-card', action: () => setIsModalOpen(true)}] : []),
        ...(!paidFor ? [{ name: 'Редактировать', icon: 'la la-edit', action: () => openEdit()}] : []),
        ...(!paidFor ? [{ name: 'Удалить', icon: 'la la-trash', action: () => onDeleteInvoice() }] : []),
    ];

    if (window.innerWidth > 1024) {
        return (
            <Content>
                <tr key={`${item.id}_item`} className="kt-datatable__row">
                    <td width="120px" className="kt-datatable__cell">
                        <span>{item.number}</span>
                    </td>
                    <td style={{textAlign: 'left'}} width="165px" className="kt-datatable__cell">
                        <span>{formatDateTime(item.date)}</span>
                    </td>
                    <td style={{ textAlign: 'center' }} width="165px" className="kt-datatable__cell">
                        <span>{item.supplier && item.supplier.name ? item.supplier.name : "Не указан"}</span>
                    </td>
                    <td width="165px" className="kt-datatable__cell">
                        <span>{fullAddress}</span>
                    </td>
                    <td width="auto" className="kt-datatable__cell">
                        <span>{item.note}</span>
                    </td>

                    <td style={{ textAlign: 'center' }} width="200px" className="kt-datatable__cell">
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            {item.payment && item.payment !== 'none' ? (
                                <>
                                    <span style={{ marginRight: '8px' }}>Оплачено {item.payment === 'cash' ? 'Наличные' : 'Расчетный счет'}</span>
                                    <span 
                                        className="kt-switch kt-switch--sm kt-switch--icon"
                                        onClick={() => setIsModalOpen(true)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={true}
                                            readOnly
                                        />
                                        <span className="new_order_switch"></span>
                                    </span>
                                </>
                            ) : (
                                <>
                                    <span style={{ marginRight: '8px' }}>Оплатить из кассы</span>
                                    <span
                                        className="kt-switch kt-switch--sm kt-switch--icon"
                                        onClick={() => setIsModalOpen(true)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={false}
                                            readOnly
                                        />
                                        <span className="new_order_switch"></span>
                                    </span>
                                </>
                            )}
                        </div>
                        <UpdatePayment
                            isOpen={isModalOpen}
                            onClose={() => setIsModalOpen(false)}
                            totalSum={parseNumToFixed(item.totalSum) || 0}
                            onPaymentMethod={handlePaymentMethod}
                            payment={item.payment}
                        />
                    </td>



                    <td style={{ textAlign: 'center' }} width="165px" className="kt-datatable__cell">
                        <span>{parseNumToFixed(item.totalSum) || 0}</span>
                    </td>
                    <td style={{ textAlign: 'center' }} width="125px" className="kt-datatable__cell">
                        <span>{item.paymented_at ? moment(item.paymented_at).format('DD.MM.YYYY HH:mm') : '-'}</span>
                    </td>
                    <td align="right" width="180px" className="kt-datatable__cell">
                        <button
                            data-tip="Просмотр"
                            className="btn btn-sm btn-clean btn-icon btn-icon-md"
                            onClick={() => history.push(`/accounting/invoice/detail/${item.id}`)}
                        >
                            <i className="la la-eye"></i>
                        </button>
                        <button
                            data-tip="Копировать"
                            className="btn btn-sm btn-clean btn-icon btn-icon-md"
                            onClick={openCopy}
                        >
                            <i className="la la-copy"></i>
                        </button>
                        {!paidFor &&
                        <>
                            <button
                            data-tip="Редактирование"
                            className="btn btn-sm btn-clean btn-icon btn-icon-md"
                            onClick={openEdit}
                            >
                                <i className="la la-edit"></i>
                            </button>
                            <button
                                data-tip="Удалить"
                                className="btn btn-sm btn-clean btn-icon btn-icon-md"
                                onClick={onDeleteInvoice}
                            >
                                <i className="la la-trash"></i>
                            </button>
                        </>
                        }
                    </td>
                </tr>
            </Content>
        );
    }

    return (
        <tr className="kt-datatable__row">
            <td colSpan="8">
                <div className='mobile_div_flex column padding10px'>
                    <div className='mobile_div_flex column_mobile430px'>
                        <div style={{ width: '100%' }}>
                            <span style={{ color: '#000' }}>№ {item.number}</span>
                        </div>
                        <div style={{ width: '100%' }}>
                            <span style={{ color: '#000' }}>{fullAddress}</span>
                        </div>
                        <div style={{ width: '100%' }}>
                            <span style={{ color: '#000' }}>{formatDateTime(item.date)}</span>
                        </div>
                        <div style={{ width: '100%' }}>
                            <span style={{ color: '#000' }}>Поставщик: {item.supplier && item.supplier.name ? item.supplier.name : "Не указан"}</span>
                        </div>
                        <div style={{ width: '100%' }}>
                            <span style={{ whiteSpace: 'nowrap' }} className={`kt-badge ${item.isPaid ? "kt-badge--danger" : "kt-badge--brand"} kt-badge--inline`}>
                                {item.payment && item.payment !== 'none' ? `Оплачено ${item.payment === 'cash' ? 'Наличные' : 'Расчетный счет'}` : "Не оплачено"}
                            </span>
                        </div>
                        <div style={{ width: '100%' }}>
                            <span style={{ color: '#000' }}>Сумма: {parseNumToFixed(item.totalSum) || 0}</span>
                        </div>
                        <div style={{ width: '100%' }}>
                            <span style={{ color: '#000' }}>Дата оплаты: {item.paymented_at ? moment(item.paymented_at).format('DD.MM.YYYY HH:mm') : '-'}</span>
                        </div>
                    </div>

                    <div className='mobile_div_flex' style={{ justifyContent: 'flex-end', marginTop: 10 }}>
                        <div className="action-buttons">
                            <ActionMenu actions={actions} />
                            <ReactTooltip effect="solid" place="top"/>
                            <UpdatePayment
                                isOpen={isModalOpen}
                                onClose={() => setIsModalOpen(false)}
                                totalSum={parseNumToFixed(item.totalSum) || 0}
                                onPaymentMethod={handlePaymentMethod}
                                payment={item.payment}
                            />
                        </div>
                    </div>

                </div>
            </td>
        </tr>
    );
};

export const ItemRow = withRouter(Item);
